export enum SubmissionStatus {
  Authentication = 'Authentication',
  AuthenticationFailed = 'AuthenticationFailed',
  Completed = 'Completed',
  Delivery = 'Delivery',
  DeliveryFailed = 'DeliveryFailed',
  UnknownError = 'UnknownError',
  Validation = 'Validation',
  ValidationFailed = 'ValidationFailed',
}
